import type { TFunction } from "i18next";

import type { ShareOutcome } from "./share-controller.js";

const AUTH_CODES = new Set(["auth_required", "auth_invalid", "auth_expired"]);

/**
 * Map a share outcome to a user-facing toast string. Returns null when
 * the outcome shouldn't surface a toast (success → handled by modal).
 */
export function shareOutcomeMessage(
  outcome: ShareOutcome,
  t: TFunction,
): string | null {
  switch (outcome.kind) {
    case "success":
      return null;
    case "cancelled":
      return t("share.cancelled");
    case "network_error":
      return t("share.errors.network");
    case "unsupported":
      return t("share.errors.unsupported");
    case "unknown_error":
      return t("share.errors.unknown", { message: outcome.message });
    case "backend_error": {
      if (AUTH_CODES.has(outcome.code)) return t("share.errors.auth");
      switch (outcome.code) {
        case "empty_post":
          return t("share.errors.empty_post");
        case "too_long": {
          const limit =
            typeof outcome.extra.limit === "number" ? outcome.extra.limit : 4096;
          return t("share.errors.too_long", { limit });
        }
        case "invalid_state":
        case "invalid_body":
        case "invalid_json":
          return t("share.errors.invalid_state");
        case "telegram_api":
          return t("share.errors.telegram_api");
        default:
          return t("share.errors.unknown", { message: outcome.code });
      }
    }
  }
}

/** Outcomes that warrant a Telegram error haptic. */
export function isErrorOutcome(outcome: ShareOutcome): boolean {
  return (
    outcome.kind === "backend_error" ||
    outcome.kind === "network_error" ||
    outcome.kind === "unknown_error"
  );
}
